export interface INotesTemplatesTableData {
    _id: string;
    name: string;
    legalForm: string;
    accountBasis: string;
}
